<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/dictation/alphabet/index')">mdi-arrow-left
            </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ساخت الفبا جدید</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="alphabet.label" label="عنوان"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-select label="نوع"
                      :items="[{value:'single',text:'حرف'},{value:'multi',text:'کلمه'},{value:'phrase',text:'عبارت'}]"
                      item-text="text" item-value="value"
                      color="black" v-model="alphabet.type">
            </v-select>
          </v-col>
          <v-col cols="6">
            <v-text-field label="کاور"
                          @click="coverDialog = true" prepend-icon="mdi-plus"
                          color="black"
                          v-model="alphabet.cover"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field label="فایل صوتی"
                          @click="audioDialog = true" prepend-icon="mdi-plus"
                          color="black"
                          v-model="alphabet.audio"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea color="black" v-model="alphabet.description" label="توضیحات الفبا"></v-textarea>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="store()">ذخیره</v-btn>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="warning" class="normal-font-btn" @click="clear()">پاک کردن</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="coverDialog" max-width="50vw">
      <drag-and-drop module="alphabet" ref="image-uploader" @closeUploadFileDialog="coverDialog = false"
                     @changeFile="alphabet.cover = $event"></drag-and-drop>
    </v-dialog>
    <v-dialog v-model="audioDialog" max-width="50vw">
      <drag-and-drop module="alphabet-audio" ref="image-uploader" @closeUploadFileDialog="audioDialog = false"
                     @changeFile="alphabet.audio = $event"></drag-and-drop>
    </v-dialog>
  </div>
</template>


<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop.vue";

export default {
  name: "AlphabetDictationCreate",
  components: {DragAndDrop},
  data() {
    return {
      coverDialog: null,
      audioDialog:null,
      alphabet: {
        label: null,
        type: null,
        cover: null,
        description: null,
        audio: null,
      },

    }
  },
  methods: {
    store() {
      window.axios.post('course/dictation/alphabet/create', this.alphabet).then(() => {
        this.openSnackbar("الفبا با موفقیت ساخته شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    clear() {
      this.alphabet = {
        label: null,
        type: null,
        cover: null,
        description: null,
        audio: null,
      }
    },
  }
}
</script>


<style scoped>

</style>